import { Card, } from '@components/1-atoms';
import React, { FC } from 'react';

import Text from '@components/1-atoms/Text';
import ListItem from '@components/2-molecules/ListItem';
import { View } from 'react-native';

import DocumentList from '@components/3-organisms/Lists/ListDocument';
import DocumentsMenu from '@components/3-organisms/Menus/MenuDocuments';

import { Modal } from '@components/1-atoms';

import useTheme from '@lib/theme';

import MenuIcon from '@assets/icons/plus';
import { PageProps } from '@lib/constants';


const theme = useTheme();
const icon = /* null; // */ <MenuIcon />;


type Props = PageProps & {
    currency: string;
};

const RecentDocuments: FC<Props> = ({ navigation, currency, data }) => {

    const [isModalVisible, setModalVisiblility] = React.useState(false);
    const openModal = () => setModalVisiblility(true);
    const closeModal = () => setModalVisiblility(false);

    // Sort documents by creation date and take the last 5.
    data = data?.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).slice(0, 5);

    return (
        <>
            <Modal visible={isModalVisible} title={"Create a document"} onClose={closeModal}>
                <DocumentsMenu navigation={navigation} />
            </Modal>

            <Card title='Recent documents' icon={icon} onAction={openModal}>

                <DocumentList
                    inset
                    scrollEnabled={false}
                    currency={currency}
                    data={data}
                    onPress={(data: any) => navigation?.navigate('DocumentView', { data: data })}
                />

                {/* View all documents */}
                <View>
                    <ListItem inset onPress={() => navigation?.navigate('Documents')}>
                        <Text bold color={theme.pallete.accentColor}>View document(s)</Text>
                    </ListItem>
                </View>

            </Card>
        </>
    );
};

export default RecentDocuments;